import { breadcrumb } from './breadcrumb';

export const mailer = {
  breadcrumb,

  mailing: {
    new_status: {
      moderation: 'На модерации',
      rejected: 'Отклонено',
      pending: 'Ожидает',
      processing: 'Обрабатывается',
      processed: 'Обработано',
      finished: 'Завершена',
      failed: 'Ошибка',
    },

    modal: {
      remove: {
        content: 'Вы уверены, что хотите удалить рассылку {name}?'
      },
      view: {
        title: 'Части сообщения'
      },
      part_number: 'Часть сообщения',
      status: 'Статус',
      client_cost: 'Стоимость'
    },

    form: {
      block: {
        sender: {
          title: 'Отправитель'
        },

        content: {
          title: 'Содержание'
        },

        recipients: {
          title: 'Получатели'
        },

        sms: {
          placeholder: 'Ваше сообщение'
        },

        date: {
          title: 'Дата доставки',
          action: 'Отложить рассылку'
        }
      },

      field: {
        sender: {
          title: 'Имя'
        },

        title: {
          title: 'Название рассылки',
          placeholder: 'Введите название'
        },

        template: {
          title: 'Шаблон',
          save_template: 'Сохранить шаблон'
        },

        macros: {
          title: 'Макрос'
        },

        body: {
          title: 'Сообщение'
        }
      }
    }
  },

  message: {
    field: {
      name: 'Название рассылки',
      src: 'Виртуальный номер отправителя',
      dst: 'Номер получателя',
      created_at: 'Дата получения сообщения',
      body: 'Текст сообщения',
      parts: 'Части',
      source_type: 'Источник',
      total_parts: 'Всего частей',
      sender_name: 'Имя сендера'
    },

    noty: {
      balance: 'На балансе недостаточно средств. SMS-рассылка приостановлена. Пополните баланс.'
    },

    setting: {
      title: 'Настройки',
      field: {
        webhook_sms_state: {
          name: 'Постбэк для статуса смс'
        },
        webhook_incoming_sms: {
          name: 'Постбэк для входящих смс',
          description: 'Укажите ваш URL, и мы сможем отправлять вам данные по входящим смс.',
          requirement:
            'Требования: данный URL должен быть доступен посредством POST запроса на него и отдавать статус - 200. Формат данных: json. Пример данных: {"src":"89876543210", "dst": "80123456789", "body": "sms text"}'
        }
      }
    },

    status: {
      delivered: 'Доставлено',
      sent: 'Отправлено',
      pending: 'Ожидает',
      not_delivered: 'Не доставлено',
      failed: 'Ошибка',
      rejected: 'Отклонено',
      expired: 'Просрочено',
      processing: 'Обработка'
    },

    status_table: {
      sent: 'Отправлено',
      pending: 'Ожидает',
      delivered: 'Доставлено',
      active: 'Активный',
      not_delivered: 'Не доставлено',
      failed: 'Ошибка',
      error: 'Ошибка',
      rejected: 'Отклонено',
      processing: 'Обработка',
      resending: 'Переотправка',
      expired: 'Просрочено'
    }
  },

  template: {
    fields: {
      body: 'Текст'
    },

    modal: {
      remove: {
        content: 'Вы уверены, что хотите удалить шаблон {name}?'
      }
    }
  },

  buttons: {
    add_senders: 'Добавить отправителя'
  },

  sender: {
    state: {
      all: 'Все',
      new: 'Новый',
      moderation: 'На модерации',
      active: 'Активный',
      canceled: 'Отклонен',
      deactivated: 'Деактивирован',
      on_deactivation: 'На деактивации'
    },

    table: {
      name: 'Имя отправителя',
      description: 'Описание',
      cost: 'Стоимость',
      deactivate: 'Деактивировать'
    },

    form: {
      create: {
        description:
          'Имя отправителя может содержать до 11 латинских букв, цифр и специальных символов(.,-_).'
      }
    },

    modal: {
      add: {
        title: 'Добавить отправителя',
        description:
          'После отправки запроса на добавление отправителя, вы увидите в столбце Описание перечень документов, необходимых для регистрации и ежемесячную стоимость Отправителя.',
        sender_name: 'Имя отправителя'
      },
      remove: {
        content: 'Вы уверены, что хотите удалить отправителя {name}?'
      },
      deactivate: {
        content: 'Вы действительно хотите деактивировать отправителя {name}?'
      }
    }
  },

  tooltips: {
    delayed_until: 'Время указывается в UTC пользователя',
    db_range: 'Указание диапазона номеров которые будут включаться в рассылку'
  },

  archived_stats: {
    general: {
      filter: {
        group_by: {
          title: 'Группировать по',
          values: {
            day: 'День',
            mailing: 'Рассылка',
            country: 'Страна',
            operator: 'Оператор',
            sender: 'Отправитель'
          }
        }
      }
    }
  },

  stats: {
    general: {
      filter: {
        group_by: {
          title: 'Группировать по',
          values: {
            day: 'День',
            mailing: 'Рассылка',
            country: 'Страна',
            sender: 'Отправитель',
            network: 'Оператор'
          }
        },

        sender: {
          title: 'Отправитель'
        },

        source: {
          title: 'Источник',
          values: {
            web: 'Веб интерфейс',
            api: 'API'
          }
        }
      },

      field: {
        total: 'Итого',
        cost: 'Стоимость',
        group: 'Дата'
      },

      block: {
        main: 'Сводная таблица'
      }
    },

    detailed: {
      filter: {
        number: {
          title: 'Номер'
        },
        status: {
          title: 'Статус'
        },
        mailing: {
          title: 'Рассылка'
        }
      },
      total: 'Всего элементов'
    }
  },
  not_sender: {
    not_sender: 'У вас нет одобренных идентификаторов отправителей.',
    to_create: 'Чтобы создать рассылку, пройдите по',
    link: 'ссылке',
    and_to_create: 'и создайте нового отправителя.'
  },
  export: {
    not_export: 'Нет данных для экспорта. Попробуйте изменить условия фильтрации.'
  }
};
